export default "__VITE_ASSET__BGAlK38N__"